import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import moment from "moment";
import { htmlToTextContent } from "./application-mixins/html-text-evaluation-mixin";
import { helpers, email, required } from "vuelidate/lib/validators";
import { DATE_FORMAT, MINIMUM_TIME_REQUIRED_MONTHS } from "./constants";
import { validSIN } from "./utils";
import { isEmpty } from "lodash";
export const asyncValidation = async (value, transformFn, validatorFn) => {
  try {
    if (typeof transformFn !== "function") throw "transformFn() needs to be a function";
    if (validatorFn) {
      if (typeof validatorFn !== "function") throw "validatorFn() needs to be a function";
      return await validatorFn(await transformFn(value));
    }
    return await transformFn(value);
  } catch (e) {
    return false;
  }
};
export const softValidate = validationFunction => helpers.withParams({
  softError: true,
  type: "softError"
}, validationFunction);
export const pastDate = value => {
  if (!value) return true;
  const date = moment(value);
  const today = moment();
  return date.isSameOrBefore(today, "day");
};
export const withPastDate = helpers.withParams({
  type: "pastDate"
}, function (value) {
  return pastDate(value);
});
export const isAdult = helpers.withParams({
  type: "pastDate"
}, function (value) {
  if (!value) return true;
  return moment().diff(value, "years") >= 18;
});
export const validPhoneNumber = helpers.withParams({
  type: "validPhoneNumber"
}, function (value) {
  if (!value) return true;
  const formattedPhoneNumber = value.replace(/[^0-9]/g, "");
  return formattedPhoneNumber.length === 10;
});
export const validPhoneNumberWithExt = helpers.withParams({
  type: "validPhoneNumber"
}, function (value) {
  if (!value || typeof value != "string") return true;
  const baseNumber = value.split("Ext");
  const formattedBaseNumber = baseNumber[0].replace(/[^0-9]/g, "");
  return formattedBaseNumber.length >= 10;
});
export const customConditional = (conditionalOptions = {}, validatorFn) => helpers.withParams({
  type: "pastDate"
}, function (value, parentModel) {
  const {
    options
  } = conditionalOptions.column || {};
  const togglerValue = parentModel == null ? void 0 : parentModel[conditionalOptions.togglerKey];
  const currentOption = _findInstanceProperty(options).call(options, option => togglerValue === option.value);
  if (!currentOption || currentOption.action === "hide") return true;
  return validatorFn(value, parentModel);
});
export const futureDate = value => {
  if (!value) return true;
  const date = moment(value);
  const today = moment();
  return date.isSameOrAfter(today, "day");
};
export const withFutureDate = helpers.withParams({
  type: "futureDate"
}, function (value) {
  return futureDate(value);
});
export const validDate = value => {
  if (!value) return true;
  const isValidFormat = moment(value, DATE_FORMAT).format(DATE_FORMAT) === value;
  return moment(value).isValid() && isValidFormat;
};
export const withValidDate = helpers.withParams({
  type: "validDate",
  format: "YYYY-MM-DD"
}, function (value) {
  return validDate(value);
});
export const requiredSin = helpers.withParams({
  type: "requiredSin"
}, function (sin = {
  1: "",
  2: "",
  3: ""
}) {
  return !!(sin != null && sin[1]) || !!(sin != null && sin[2]) || !!(sin != null && sin[3]);
});
export const withValidSin = helpers.withParams({
  type: "validSin",
  format: "YYYY-MM-DD"
}, function (value) {
  if (isEmpty(value) || _Object$keys(value).every(section => !value[section])) return true;
  const {
    1: sin1,
    2: sin2,
    3: sin3
  } = value || {};
  const sinIsFullX = /^\d{3}$/.test(sin1) && sin2 === "XXX" && sin3 === "XXX";
  if (sinIsFullX) return true;
  const sin = `${sin1}${sin2}${sin3}`;
  return validSIN(sin);
});
export const minTimeAtGroup = (field, min = MINIMUM_TIME_REQUIRED_MONTHS) => helpers.withParams({
  type: "minTimeAtGroup",
  min,
  field,
  softError: true
}, function (value) {
  const total = (value == null ? void 0 : _reduceInstanceProperty(value).call(value, (acc, current) => {
    acc += _parseInt(current[field] || "") || 0;
    return acc;
  }, 0)) || 0;
  return total >= min;
});
export const multipleEmail = (value = "") => {
  const isArray = Array.isArray(value);
  if (!isArray && _trimInstanceProperty(value).call(value) === "") return true;
  const emails = isArray ? value : value.split(/[,]+/);
  return emails.every(emailToTest => email(emailToTest));
};
export const requiredHTML = value => htmlToTextContent(value) !== "";
export const unique = arrayToMatch => value => !_includesInstanceProperty(arrayToMatch).call(arrayToMatch, value);
export const notSameAs = notValue => value => {
  if (Array.isArray(notValue)) return _includesInstanceProperty(notValue).call(notValue, value);
  return value != notValue;
};
export const validPassword = helpers.regex("validPassword", /^(?=.*[A-Z])(?=.*[!@#$&*+])(?=.*[0-9])(?=.*[a-z]).{12,24}$/);
export const validOldPassword = helpers.regex("validOldPassword", /^(?=.*[A-Z])(?=.*[!@#$&*+])(?=.*[0-9])(?=.*[a-z]).{8,24}$/);
export const validSignedNumber = helpers.regex("validSignedNumber", /^[+-][0-9.]+$/);
export const sameAsWithLabel = label => equalTo => helpers.withParams({
  type: "sameAs",
  eq: equalTo,
  label
}, function (value, parentVm) {
  return value === helpers.ref(equalTo, this, parentVm);
});
export const emailCaseInsensitive = value => {
  return email(value.toLowerCase());
};
export const validSubdomain = helpers.regex("validSubdomain", /^[a-z0-9][a-z0-9-]*[a-z0-9]$/);
export const isValidColor = color => {
  return color.toLowerCase().match(/^#[a-f0-9]{6}$/i) !== null;
};
export const validExpirationDate = value => {
  var _date$, _date$2;
  const validFormat = value.match(/(0[1-9]|10|11|12)\/20[0-9]{2}$/gm) !== null;
  const date = value.split("/");
  const dateParts = [_parseInt((_date$ = date == null ? void 0 : date[1]) != null ? _date$ : 0), _parseInt((_date$2 = date == null ? void 0 : date[0]) != null ? _date$2 : 0), 0];
  return validFormat && futureDate(new Date(dateParts[0], dateParts[1], dateParts[2]).toISOString());
};
export const validCanadianPostalCode = value => {
  if (value == null) {
    return false;
  }
  return value.match(/^([A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9]){0,1}$/gm) !== null;
};
export const requiredAddressValidation = () => ({
  line1: {
    required
  },
  "street-number": {
    required
  },
  "street-name": {
    required
  },
  city: {
    required
  },
  province: {
    required
  },
  "postal-code": {
    required,
    validCanadianPostalCode
  }
});
export const anyRequired = (otherValues, requiredValidator = helpers.req) => helpers.withParams({
  type: "required"
}, function (vmValue) {
  if (!requiredValidator(vmValue)) {
    return otherValues.some(requiredValidator);
  }
  return requiredValidator(vmValue);
});
export const emailMultiple = value => {
  if (_trimInstanceProperty(value).call(value) === "") return true;
  const emails = value.split(/[,]+/);
  let valid = true;
  for (const i in emails) {
    value = emails[i];
    valid = valid && /^((([a-zA-Z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-zA-Z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/.test(_trimInstanceProperty(value).call(value));
  }
  return valid;
};